import { probabilities } from 'src/enums/simulations';

export const PROBABILITIES = [probabilities.MEAN, 10, 50, 90];
